import clsx from 'clsx'

import mainStyles from 'assets/css/main.module.scss'

import styles from './Questions.module.scss'
import { QuestionsData } from './QuestionsData'
import BlueBubbles from '../../assets/images/questions/blue_bubbles.svg'
import DotsBottomRight from '../../assets/images/questions/dot_element_bottomright.svg'
import DotsLeft from '../../assets/images/questions/dot_element_left.svg'
import DotsTopRight from '../../assets/images/questions/dot_element_topright.svg'
import { Flex } from '../common/flex/Flex'

const Questions = () => {
  return (
    <div className={clsx(styles.container, 'mb-16')}>
      <Flex justify="center" align="center" className={styles.headerContainer}>
        <div>
          <img src={BlueBubbles} alt="Yellow Bubbles" className={styles.yellowBubbles} />
        </div>
        <h4 className={clsx(mainStyles.h4, 'text-[#F4F4F4]')}>Got questions? We’ve got answers</h4>
      </Flex>
      <Flex direction="column" gap={32} className={styles.questionsList}>
        <div className={styles.dotsLeft}>
          <img src={DotsLeft} alt="dots" />
        </div>
        <div className={styles.dotsTopRight}>
          <img src={DotsTopRight} alt="dots" />
        </div>
        <div className={styles.dotsBottomRight}>
          <img src={DotsBottomRight} alt="dots" />
        </div>
        {QuestionsData.map((question, index) => (
          <Flex key={index} gap={24}>
            <div>
              <svg xmlns="http://www.w3.org/2000/svg" width="60" height="61" viewBox="0 0 60 61" fill="none">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M29.9991 17.279C31.1743 17.279 32.1269 18.2317 32.1269 19.4069V33.5927C32.1269 34.7679 31.1743 35.7205 29.9991 35.7205C28.8239 35.7205 27.8712 34.7679 27.8712 33.5927V19.4069C27.8712 18.2317 28.8239 17.279 29.9991 17.279Z"
                  fill="black"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M6.00143 30.6373C6.00143 17.3841 16.7459 6.63965 29.9991 6.63965C43.2523 6.63965 53.9967 17.3841 53.9967 30.6373C53.9967 43.8905 43.2523 54.6349 29.9991 54.6349C26.0834 54.6349 22.3902 53.6888 19.1263 52.0242L10.2048 54.5138C10.2045 54.5139 10.2052 54.5137 10.2048 54.5138C7.71972 55.2078 5.43182 52.9184 6.12598 50.4356L8.6167 41.5184C6.94988 38.2523 6.00143 34.5557 6.00143 30.6373ZM29.9991 10.8954C19.0962 10.8954 10.2572 19.7345 10.2572 30.6373C10.2572 34.1222 11.1674 37.3889 12.7538 40.233C13.0273 40.7231 13.0959 41.3014 12.945 41.842L10.6764 49.9638L18.8031 47.696C19.3434 47.5452 19.9213 47.6139 20.4112 47.887C23.2527 49.471 26.516 50.3792 29.9991 50.3792C40.9019 50.3792 49.741 41.5401 49.741 30.6373C49.741 19.7345 40.9019 10.8954 29.9991 10.8954ZM9.05879 50.4152C9.05843 50.4153 9.05915 50.4151 9.05879 50.4152V50.4152Z"
                  fill="black"
                />
                <path
                  d="M29.9991 43.6409C31.3048 43.6409 32.3634 42.5824 32.3634 41.2766C32.3634 39.9709 31.3048 38.9123 29.9991 38.9123C28.6933 38.9123 27.6348 39.9709 27.6348 41.2766C27.6348 42.5824 28.6933 43.6409 29.9991 43.6409Z"
                  fill="black"
                />
              </svg>
            </div>
            <Flex direction="column" gap={16} key={index} className={styles.questionItem}>
              <h5 className={clsx(mainStyles.h5, 'text-[#026A66]')}>{question.title}</h5>
              <p className={clsx(mainStyles.text, 'text-[#191919]')}>{question.description}</p>
            </Flex>
          </Flex>
        ))}
      </Flex>
    </div>
  )
}

export default Questions
